import { useState } from "react";
import { useParams } from "react-router-dom";
import { MkCard } from "@/components/mk/MkCard";
import { SectionHeading } from "@/components/site/ui";
import { useFetch } from "@/lib/useFetch";
import { useSeo } from "@/lib/seo";

const CONFIG = {
    opportunities: { eyebrow: "Marketplace", title: "Find Your Next Brand Opportunity", sub: "One platform. Hundreds of ways to get your brand noticed.", cats: ["ALL", "PODCASTS", "EVENTS", "SEMINARS", "WEBINARS", "INFLUENCERS", "MEDIA", "SPONSORSHIPS", "CONTENT", "NETWORKING"] },
    experts: { eyebrow: "Experts", title: "Your Next Big Move Starts With the Right Expert", sub: "Connect with verified professionals across PR, brand, social and more." },
    influencers: { eyebrow: "Creators", title: "Find Creators Your Audience Already Trusts", sub: "Collaborate with verified influencers across every category." },
    podcasts: { eyebrow: "Podcasts", title: "Get Your Story on the Mic", sub: "Apply as a guest on podcasts your audience is already listening to." },
    events: { eyebrow: "Events", title: "Where Business Happens", sub: "Discover events, seminars and webinars to put your brand in the room." },
    brands: { eyebrow: "Brands", title: "Brands Making Noise", sub: "Discover brands building their presence on SuDigi." },
};

export default function MarketplaceList({ kind }) {
    const params = useParams();
    const k = kind || params.kind;
    const cfg = CONFIG[k] || CONFIG.opportunities;
    const [cat, setCat] = useState("ALL");
    const { data, loading } = useFetch(`/mk/${k}`, []);
    useSeo({ title: `${cfg.title} | SuDigi`, description: cfg.sub });

    const items = (data || []).filter((it) => cat === "ALL" || !cfg.cats || it.category === cat);

    return (
        <section className="bg-teal-900 py-14 min-h-[70vh]">
            <div className="container-x">
                <div className="text-center flex flex-col items-center mb-8"><SectionHeading center eyebrow={cfg.eyebrow} title={cfg.title} subtitle={cfg.sub} /></div>
                {cfg.cats && (
                    <div className="flex flex-wrap justify-center gap-2 mb-10">
                        {cfg.cats.map((c) => (
                            <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-xs font-semibold transition-colors ${cat === c ? "bg-gold text-teal-900" : "border border-brandborder text-cream-soft hover:border-gold"}`} data-testid={`cat-${c}`}>{c}</button>
                        ))}
                    </div>
                )}
                {loading ? <div className="text-center text-cream-soft py-16">Loading…</div> : items.length === 0 ? (
                    <div className="text-center py-20 text-cream-soft"><p className="font-serif text-2xl text-cream">No {k} yet.</p><p className="mt-2">Your next opportunity could start here.</p></div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{items.map((it) => <MkCard key={it.slug} item={it} kind={k} />)}</div>
                )}
            </div>
        </section>
    );
}
